import { APP_NAME, metafieldFields } from "../fields";

export const isOfflineMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "isoffline")',
    alias: "isOffline",
  },
  fields: metafieldFields,
  variables: {},
};

export const instagramMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "instagram")',
    alias: "instagram",
  },
  fields: metafieldFields,
  variables: {},
};

export const serialNumberMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "serial_number")',
    alias: "serialNumber",
  },
  fields: metafieldFields,
  variables: {},
};

export const scoreMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "score")',
    alias: "score",
  },
  fields: metafieldFields,
  variables: {},
};

export const productCodeMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "product_code")',
    alias: "productCode",
  },
  fields: metafieldFields,
  variables: {},
};

export const drawStatusMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "draw_status")',
    alias: "drawStatus",
  },
  fields: metafieldFields,
  variables: {},
};

const returnStatusName: Record<string, string> = {
  tune: '(namespace: "custom", key: "return_status")',
  yeseyesee: '(namespace: "return", key: "status")',
  thisisneverthat: '(namespace: "return", key: "status")',
  khakis: '(namespace: "return", key: "status")',
  sunlove: '(namespace: "return", key: "status")',
  wellbeingexpress: '(namespace: "return", key: "status")',
};

export const returnStatusMetafield = {
  operation: {
    name: `metafield${returnStatusName[APP_NAME]}`,
    alias: "returnStatus",
  },
  fields: metafieldFields,
  variables: {},
};

export const returnImagesMetafield = {
  operation: {
    name: 'metafield(namespace: "return", key: "images")',
    alias: "returnImages",
  },
  fields: metafieldFields,
  variables: {},
};

export const featuredImageMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "featured_image")',
    alias: "featuredImage",
  },
  fields: metafieldFields,
  variables: {},
};

export const isFamilySaleMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "isfamilysale")',
    alias: "isfamilysale",
  },
  fields: metafieldFields,
  variables: {},
};

export const brandStoreOrderIdMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "brand_store_order_id")',
    alias: "brandStoreOrderIds",
  },
  fields: metafieldFields,
  variables: {},
};

// khakis Gifting Order Metafield
export const giftingMessageTemplateMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "gifting_message_template")',
    alias: "giftingMessageTemplate",
  },
  fields: metafieldFields,
  variables: {},
};

export const giftingTokenMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "gifting_token")',
    alias: "giftingToken",
  },
  fields: metafieldFields,
  variables: {},
};

export const giftingIsAcceptedMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "gifting_is_accepted")',
    alias: "giftingIsAccepted",
  },
  fields: metafieldFields,
  variables: {},
};

// khakis Raffle Order Metafield
export const isRaffleOrderMetafield = {
  operation: {
    name: 'metafield(namespace: "raffle", key: "is_raffle_order")',
    alias: "isRaffleOrder",
  },
  fields: metafieldFields,
  variables: {},
};

export const raffleIsOfflinePickupMetafield = {
  operation: {
    name: 'metafield(namespace: "raffle", key: "isoffline")',
    alias: "raffleIsOfflinePickup",
  },
  fields: metafieldFields,
  variables: {},
};

export const raffleShippingMethodMetafield = {
  operation: {
    name: 'metafield(namespace: "raffle", key: "shipping_method")',
    alias: "raffleShippingMethod",
  },
  fields: metafieldFields,
  variables: {},
};

export const raffleInstagramMetafield = {
  operation: {
    name: 'metafield(namespace: "raffle", key: "instagram")',
    alias: "raffleInstagram",
  },
  fields: metafieldFields,
  variables: {},
};

export const raffleCustomerNameMetafield = {
  operation: {
    name: 'metafield(namespace: "raffle", key: "customer_name")',
    alias: "raffleCustomerName",
  },
  fields: metafieldFields,
  variables: {},
};

export const rafflePhoneMetafield = {
  operation: {
    name: 'metafield(namespace: "raffle", key: "phone")',
    alias: "rafflePhone",
  },
  fields: metafieldFields,
  variables: {},
};

export const raffleStatusMetafield = {
  operation: {
    name: 'metafield(namespace: "raffle", key: "status")',
    alias: "raffleStatus",
  },
  fields: metafieldFields,
  variables: {},
};

export const raffleCardInfoMetafield = {
  operation: {
    name: 'metafield(namespace: "raffle", key: "card_info")',
    alias: "raffleCardInfo",
  },
  fields: metafieldFields,
  variables: {},
};

export const raffleBrandPayMethodIdMetafield = {
  operation: {
    name: 'metafield(namespace: "raffle", key: "brandpay_method_id")',
    alias: "raffleBrandPayMethodId",
  },
  fields: metafieldFields,
  variables: {},
};
